import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import axiosInst from "../../../Config";
import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import {
  ModalDailog,
  ModalBody,
} from "../../Appointment/AddAppointment/StyledComponents";
import { Image } from "../../StyledComponents";
import { Container, RespDiv, ScrollBody } from "./styles";
import RefillRequestPopup from "../RefillRequest/RefillRequestPopup";
import NoAppointmentImage from "../../../Assets/images/no_appt_image.png";

const RefillRequest = ({ onScheduleClick }) => {
  const [refillList, setRefillList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isRefillRequest, setIsRefillRequest] = useState(false);

  const Pat_ID = localStorage.getItem("PID") && Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  useEffect(() => {
    if (!Pat_ID) return;
    setLoading(true);

    // const encrypted = Encrypt_Value({ pid: Pat_ID }, "vozoportal");

    axiosInst
      .get(`/vozoportal/patient/refillRequest`, {
        params: { pid: Pat_ID },
      })
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozoportal");
        setRefillList(Array.isArray(decrypted) ? decrypted : []);
      })
      .catch((err) => {
        console.error(err);
        setRefillList([]);
      })
      .finally(() => setLoading(false));
  }, [Pat_ID]);
  const refreshData = () => {
    axiosInst
      .get(`/vozoportal/patient/refillRequest`, {
        params: { pid: Pat_ID },
      })
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozoportal");
        setRefillList(Array.isArray(decrypted) ? decrypted : []);
      })
      .catch((err) => {
        console.error(err);
        setRefillList([]);
      })
      .finally(() => setLoading(false));
  };

  const getStatusStyle = (status) => {
    switch (String(status)) {
      case "1":
        return { background: "#DCFCE7", color: "#166534", label: "Approved" };
      case "0":
        return { background: "#FEE2E2", color: "#991B1B", label: "Cancelled" };
      default:
        return { background: "#2E2E2E1A", color: "#414141", label: "Submitted" };
    }
  };

    const getUrgencyStyle = (urgency) => {
      console.log()
    switch (String(urgency)) {
      case "Urgency":
        return { background: "#ffb571", color: "#d29a20", label: "Urgency" };
      case "High":
        return { background: "#ffc3c3", color: "#be2222", label: "High" };
      case "Medium":
        return { background: "#fcffa5", color: "#d7ba28", label: "Medium" };
      default:
        return { background: "#c0ffaa", color: "#2acb3f", label: "Low" };
    }
  };

  return (
    <RespDiv
      width="100%"
      height="100%"
      backColor="#FFFFFF"
      padding="0px"
      marginTop="8px"
    >
      <Container>
        {/* Header */}
        <div
          style={{
            background: "#ffffff",
            padding: "14px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "6px",
            marginBottom: "2px",
          }}
        >
          <div
            style={{ color: "#2E2E2E", fontWeight: "600", fontSize: "20px" }}
          >
            Refill Request List
          </div>
          <button
            onClick={() => setIsRefillRequest(true)}
            style={{
              background: "#407BFF",
              color: "#FFFFFF",
              border: "none",
              padding: "9px 16px",
              borderRadius: "6px",
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = "#2C6EF2")}
            onMouseOut={(e) => (e.currentTarget.style.background = "#407BFF")}
          >
            New Refill Request
          </button>
        </div>

        {/* Table */}
        <div
          style={{
            width: "100%",
            margin: 0,
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
          }}
        >
          {/* Column headers */}
          <div
            style={{
              display: "grid",
              background: "#F1F5F8",
              gridTemplateColumns:
                "minmax(180px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) minmax(140px, 1fr)",
              width: "100%",
              padding: "12px 20px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#407BFF",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            <div>Medicine Name</div>
            <div>Dosage</div>
            <div>Quantity</div>
            <div>Urgency</div>
            <div>Status</div>
          </div>

          <ScrollBody>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "260px",
                  color: "#6B7280",
                  fontSize: "14px",
                }}
              >
                Loading...
              </div>
            ) : refillList.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "260px",
                }}
              >
                <Image
                  loading="lazy"
                  src={NoAppointmentImage}
                  height="230px"
                  width="308px"
                />
              </div>
            ) : (
              refillList.map((item) => {
                const statusStyle = getStatusStyle(item.requestStatus);
                                const urgencyStyle = getUrgencyStyle(item.urgency);

                return (
                  <div
                    key={item.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "minmax(180px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) minmax(140px, 1fr)",
                      width: "100%",
                      padding: "14px 20px",
                      alignItems: "center",
                      borderBottom: "1px solid #F1F1F1",
                      fontSize: "12px",
                    }}
                  >
                    {/* Medicine Name */}
                    <div style={{ fontWeight: "500" }}>
                      {item.medicine_name || item.drug_name || "—"}
                    </div>

                    {/* Dosage */}
                    <div>{item.dosage || "—"}</div>

                    {/* Quantity */}
                    <div>{item.quantity || "—"}</div>

                    {/* Urgency */}
                    <div style={{minWidth:"30px"}}>
                      <span
                        style={{
                          padding: "3px 10px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "600",
                          background: urgencyStyle.background,
                          color: urgencyStyle.color,
                          minWidth:"30px"
                        }}
                      >
                        {item.urgency || "—"}
                      </span>
                    </div>

                    {/* Status badge */}
                    <div>
                      <span
                        style={{
                          padding: "2px 10px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "600",
                          background: statusStyle.background,
                          color: statusStyle.color,
                        }}
                      >
                        {statusStyle.label}
                      </span>
                    </div>
                  </div>
                );
              })
            )}
          </ScrollBody>
        </div>
      </Container>

      {isRefillRequest && (
        <ModalDailog>
          <ModalBody>
            <RefillRequestPopup
              onClose={() => setIsRefillRequest(false)}
              refreshData={refreshData}
            />
          </ModalBody>
        </ModalDailog>
      )}
    </RespDiv>
  );
};

export default RefillRequest;
